import { defineComponent, h } from 'vue';
import { QInput } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import { wrapPropertyGridRow } from './pg2Wrap.jsx';

export default defineComponent({
    name: 'form2-number',
    components: { QInput },
    data: function () {
        return {};
    },
    created() {},
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        sync(prop, value) {
            const v = parseFloat(value);
            this.cmodel[prop] = v;
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        propertygrid: false,
        arrayItemInline: { type: Boolean, default: false },
    },
    render() {
        if (!this.Condition) return null;

        let desc;
        if (this.schema.description)
            desc = (
                <i
                    class="mdi mdi-information"
                    title={this.schema.description}
                    style={{ color: 'var(--v-checkboxGrey-base)', fontSize: 'small', marginLeft: '3px' }}
                ></i>
            );

        const name = <span style={{ marginLeft: this.child * 15 + 'px' }}>{this.name}</span>;

        let input;
        if (this.readonly)
            input = (
                <QInput
                    type="number"
                    borderless
                    dense
                    hide-bottom-space
                    style={{ width: '100%' }}
                    modelValue={this.cmodel[this.schemakey]}
                    readonly
                />
            );
        else
            input = (
                <QInput
                    type="number"
                    borderless
                    dense
                    hide-bottom-space
                    style={{ width: '100%' }}
                    modelValue={this.cmodel[this.schemakey]}
                    onUpdate:modelValue={(value) => this.sync(this.schemakey, value)}
                />
            );

        return wrapPropertyGridRow(
            this,
            () => (
                <span class="c-PropertyGrid2__labelInner">
                    {name} {desc}
                </span>
            ),
            () => input,
        );
    },
});
